import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SubscriptionWidgetComponent } from './subscription-widget.component';
import { AppModalModule } from '../../modal/modal.module';


@NgModule({
  imports: [
    CommonModule,
    AppModalModule,
  ],
  declarations: [
    SubscriptionWidgetComponent,
  ],
  exports: [
    SubscriptionWidgetComponent,
  ],
  providers: []
})
export class SubscriptionWidgetModule { }
